// TODO: Backend API must provide fields in one style (kebab or camel not both as is)
export const FORM_DATA_KEYS_MAP = {
  numAdults: 'numadults',
  numChildren: 'numchildren',
  contactsAgree: 'contacts_agree',
  destination: 'destination',
  policyDate: 'policy_date',
  firstName: 'first_name',
  familyName: 'last_name',
  qatarId: 'qatar_id',
  passportNumber: 'passport_number',
  dateOfBirth: 'birth_date',
}

export const APPLE_PAY_PAYMENT_OPTIONS = ['APPLEPAY', 'AP']
export const AVAILABLE_PAYMENT_OPTIONS = ['CC', 'DC', ...APPLE_PAY_PAYMENT_OPTIONS]

export const NEW_TRAVELER_ID = 0
